import React from 'react'
import { CFView, Text } from 'components'
import { css } from 'emotion'
import { logo } from 'images'
import { MEDIA_QUERY } from 'styles'

export default ({
  AddressInputElement,
  AptNumberInputElement,
  DeliveryInstructionsInputElement,
  CancelButtonElement,
  SubmitButtonElement,
}) => (
  <div className={styles.container}>
    <CFView column w="100%">
      <CFView mb="1rem">
        <Text heading2 h3 black center>
          Please enter your address:
        </Text>
      </CFView>
      <CFView mb="2rem">{AddressInputElement}</CFView>
      <CFView mb="1rem">
        <Text heading2 h3 black center>
          Apt Number:
        </Text>
      </CFView>
      <CFView mb="2rem">{AptNumberInputElement}</CFView>
      <CFView mb="1rem">
        <Text heading2 h3 black center>
          Delivery Instructions:
        </Text>
      </CFView>
      <CFView mb="2rem">{DeliveryInstructionsInputElement}</CFView>
      <CFView row justifyBetween mt="2rem">
        {CancelButtonElement}
        {SubmitButtonElement}
      </CFView>
    </CFView>
  </div>
)

const styles = {
  container: css({
    backgroundColor: 'white',
    border: '3px solid #000',
    color: 'white',
    padding: '4rem',
    borderRadius: '1rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '52rem',
    [MEDIA_QUERY.SM]: {
      padding: '2rem',
      width: '100%',
    },
  }),
}
